export const SET_FILTER = 'SET_FILTER';
export const SET_HASSEARCH = 'SET_HASSEARCH';
export const SET_BUTTONTIMEOUT = 'SET_BUTTONTIMEOUT';